// [COPIAR CÓDIGO]
//
// /* GS://PROTOCOLO
//  * Arquivo: C:\Users\Usuario\GoldenSisters_Project\goldensisters_admin_web\src\services\gs_nf_module_dataModel.js
//  * Dossiê de Projeto e Manual de Colaboração: Ecossistema GoldenSisters
//  * Versão: 1.1 – Inclusão oficial de assembly_orders (Ordens de Montagem) no data model.
//  * Impacto da Versão: [src/services/gs_nf_module_dataModel.js]
//  * Data: 27/11/2025
//  * Responsável: ChatGPT (conforme Protocolo)
//  *
//  * Mudanças desta versão:
//  * - ADICIONADO: Coleção assembly_orders para representar a “ordem de montagem” (workflow).
//  * - ADICIONADO: Enum ASSEMBLY_ORDER_STATUS e modelo ASSEMBLY_ORDER_MODEL, ligado ao ciclo NF/Lote/Banho/Montagem/Estoque.
//  * - MANTIDO: Todo o contrato anterior de NF, Itens, Lotes, Produtos, Banho, Montagens, Produto Comercial, Movimentos de Estoque e Entradas Financeiras.
//  */
//

// ╔══════════════════════════════════════════════════════════════════════════╗
// ║                     COLEÇÕES OFICIAIS DO NOVO MÓDULO                     ║
// ╚══════════════════════════════════════════════════════════════════════════╝

// Coleções principais (nomes literais usados no Firestore)
export const NF_ENTRIES_COLLECTION           = 'nf_entries';             // NFs de entrada
export const NF_ITEMS_COLLECTION             = 'nf_items';               // Itens linha a linha da NF
export const LOTS_COLLECTION                 = 'lots';                   // Lotes gerados a partir da NF
export const RAW_PRODUCTS_COLLECTION         = 'raw_products';           // Produtos brutos (matéria-prima)
export const FINISHED_PRODUCTS_COLLECTION    = 'finished_products';      // Produtos prontos (pós-NF ou pós-banho)
export const BATH_OPERATIONS_COLLECTION      = 'bath_operations';        // Operações de banho
export const ASSEMBLIES_COLLECTION           = 'assemblies';             // Montagens / composições (registro final)
export const COMMERCIAL_PRODUCTS_COLLECTION  = 'commercial_products';    // Produto comercial final (PDV/Catálogo)
export const INVENTORY_MOVEMENTS_COLLECTION  = 'inventory_movements';    // Movimentos de estoque
export const FINANCIAL_INPUTS_COLLECTION     = 'financial_inputs';       // Despesas e rateios vinculados a NF/lotes

// NOVO: Ordens de Montagem (workflow da montagem)
export const ASSEMBLY_ORDERS_COLLECTION      = 'assembly_orders';        // Ordens de montagem (do pedido até a baixa)

// Objeto consolidado com as coleções
export const GSM_COLLECTIONS = {
  NF_ENTRIES: NF_ENTRIES_COLLECTION,
  NF_ITEMS: NF_ITEMS_COLLECTION,
  LOTS: LOTS_COLLECTION,
  RAW_PRODUCTS: RAW_PRODUCTS_COLLECTION,
  FINISHED_PRODUCTS: FINISHED_PRODUCTS_COLLECTION,
  BATH_OPERATIONS: BATH_OPERATIONS_COLLECTION,
  ASSEMBLIES: ASSEMBLIES_COLLECTION,
  COMMERCIAL_PRODUCTS: COMMERCIAL_PRODUCTS_COLLECTION,
  INVENTORY_MOVEMENTS: INVENTORY_MOVEMENTS_COLLECTION,
  FINANCIAL_INPUTS: FINANCIAL_INPUTS_COLLECTION,
  ASSEMBLY_ORDERS: ASSEMBLY_ORDERS_COLLECTION,
};

// ╔══════════════════════════════════════════════════════════════════════════╗
// ║                              ENUMERAÇÕES                                 ║
// ╚══════════════════════════════════════════════════════════════════════════╝

// Tipo de item da NF (linha)
export const ITEM_TYPES = Object.freeze({
  BRUTA: 'BRUTA',         // Peça bruta (matéria-prima)
  PRONTA: 'PRONTA',       // Peça pronta (acabada)
  SERVICO: 'SERVICO',     // Serviço (ex.: banho, ródio, etc.)
});

// Status de produtos e peças
export const PRODUCT_STATUS = Object.freeze({
  BRUTA: 'BRUTA',                        // Matéria-prima (aguardando destinação)
  EM_TRATAMENTO: 'EM_TRATAMENTO',        // Pronta mas ainda sem tratamento comercial
  AGUARDANDO_DESTINACAO: 'AGUARDANDO_DESTINACAO',
  DISPONIVEL: 'DISPONIVEL',              // Disponível para venda
  INDISPONIVEL: 'INDISPONIVEL',          // Bloqueada/fora de linha
  COMPOSICAO_INCOMPLETA: 'COMPOSICAO_INCOMPLETA',
  RESERVADA: 'RESERVADA',                // Reservada em PDV
});

// Status do lote
export const LOT_STATUS = Object.freeze({
  ABERTO: 'ABERTO',
  PROCESSANDO_BANHO: 'PROCESSANDO_BANHO',
  PROCESSANDO_MONTAGEM: 'PROCESSANDO_MONTAGEM',
  FECHADO: 'FECHADO',
});

// Tipos de movimento de estoque
export const INVENTORY_MOVEMENT_TYPES = Object.freeze({
  NF_ENTRADA: 'NF_ENTRADA',            // Entrada via NF
  BANHO_ENTRADA: 'BANHO_ENTRADA',      // Entrada pós-banho
  BANHO_SAIDA: 'BANHO_SAIDA',          // Saída para banho
  MONTAGEM_SAIDA: 'MONTAGEM_SAIDA',    // Saída de componentes de montagem
  MONTAGEM_ENTRADA: 'MONTAGEM_ENTRADA',// Entrada de produto montado
  AJUSTE_MANUAL: 'AJUSTE_MANUAL',      // Ajustes administrativos
  VENDA_SAIDA: 'VENDA_SAIDA',          // Saída por venda
});

// Tipos de montagem (para futura diferenciação, se necessário)
export const ASSEMBLY_TYPES = Object.freeze({
  SIMPLES: 'SIMPLES',                  // Ex.: pingente + corrente
  COMPLEXA: 'COMPLEXA',                // Combinações com múltiplos componentes
});

// Tipos de custos financeiros vinculados à NF para rateio
export const FINANCIAL_INPUT_TYPES = Object.freeze({
  FRETE: 'FRETE',
  PEDAGIO: 'PEDAGIO',
  COMBUSTIVEL: 'COMBUSTIVEL',
  ALIMENTACAO: 'ALIMENTACAO',
  OUTROS: 'OUTROS',
});

// NOVO: Status de Ordem de Montagem
export const ASSEMBLY_ORDER_STATUS = Object.freeze({
  ABERTA: 'ABERTA',            // Criada, aguardando execução
  EM_ANDAMENTO: 'EM_ANDAMENTO',// Em execução no setor de montagem
  CONCLUIDA: 'CONCLUIDA',      // Executada e baixada
  CANCELADA: 'CANCELADA',      // Ordem cancelada
});

// ╔══════════════════════════════════════════════════════════════════════════╗
// ║                       MODELOS DE DADOS (CONTRATO)                        ║
// ╚══════════════════════════════════════════════════════════════════════════╝
//
// Observação importante:
// Estes objetos representam o "shape" esperado dos documentos no Firestore.
// Não são schemas rígidos, mas o padrão oficial a ser seguido por todas as telas
// e serviços do novo módulo.

// ─────────────────────────────────────────────────────────────────────────────
// 1) NF DE ENTRADA (NF_ENTRIES)
// ─────────────────────────────────────────────────────────────────────────────

export const NF_ENTRY_MODEL = {
  // Identificação da NF
  nfNumber: '',            // Número da NF (string exata da nota)
  supplierId: '',          // Referência ao fornecedor (coleção suppliers ou equivalente)
  nfDate: null,            // Data da NF (Timestamp/Date)
  createdAt: null,         // Data/hora de criação no sistema (Timestamp/Date)
  createdByUserId: '',     // Usuário do painel que registrou a NF

  // Relacionamento com lote
  lotId: null,             // ID do lote gerado a partir desta NF

  // Totais e controle
  grossTotal: 0,           // Soma dos valores brutos dos itens
  servicesTotal: 0,        // Soma dos serviços (se registrarmos via NF)
  expensesTotal: 0,        // Soma das despesas adicionais de rateio
  grandTotal: 0,           // Total geral após rateios
  currency: 'BRL',         // Moeda

  // Rateios (frete, pedágio, etc.) cadastrados diretamente na NF
  expensesBreakdown: [],   // Array de objetos FINANCIAL_INPUT_MODEL (simplificado por NF)

  // Campos auxiliares para telas (ex.: Histórico NF)
  totalItems: 0,           // Quantidade total de linhas de itens
  itemsCount: 0,           // Alias de totalItems (para conveniência de UI)

  // Metadados
  status: 'REGISTRADA',    // Status simples da NF (REGISTRADA, CANCELADA, etc. — pode evoluir)
  notes: '',               // Observações gerais da NF
};

// ─────────────────────────────────────────────────────────────────────────────
// 2) ITENS DA NF (NF_ITEMS)
// ─────────────────────────────────────────────────────────────────────────────

export const NF_ITEM_MODEL = {
  nfId: '',                        // Referência à NF de origem
  lineNumber: 1,                   // Linha da NF (1,2,3,...)
  itemType: ITEM_TYPES.BRUTA,      // BRUTA | PRONTA | SERVICO

  // Dados do fornecedor
  supplierId: '',                  // Mesmo fornecedor da NF (na maioria dos casos)
  supplierItemCode: '',            // Código do item na nota/fornecedor
  supplierItemName: '',            // Nome do item conforme NF

  // Classificação
  categoryId: null,                // Categoria GS (opcional no momento da NF)
  tags: [],                        // Tags livres

  // Quantidade e unidade
  quantity: 0,                     // Quantidade comprada
  unit: 'un',                      // 'un', 'g', 'kg', etc.

  // Peso (obrigatório se BRUTA)
  rawWeight: 0,                    // Peso unitário bruto (em gramas, se aplicável)

  // Custos
  unitValue: 0,                    // Valor unitário conforme NF
  grossCost: 0,                    // Custo bruto total (quantity * unitValue)
  rateioCost: 0,                   // Parcela de rateio atribuída a este item
  finalCost: 0,                    // Custo final do item na NF (grossCost + rateioCost)

  // Relacionamentos
  lotId: null,                     // Lote originado a partir da NF
  linkedRawProductId: null,        // Produto bruto gerado (se itemType = BRUTA)
  linkedFinishedProductId: null,   // Produto pronto gerado (se itemType = PRONTA)

  // Metadados
  createdAt: null,
  createdByUserId: '',
};

// ─────────────────────────────────────────────────────────────────────────────
// 3) LOTES (LOTS)
// ─────────────────────────────────────────────────────────────────────────────

export const LOT_MODEL = {
  nfId: '',                        // NF que originou o lote
  lotNumber: '',                   // Número do lote (padrão GS, ex.: L2025-0001)
  supplierId: '',                  // Fornecedor principal da NF
  createdAt: null,                 // Data de criação do lote
  createdByUserId: '',

  // Status de processamento
  status: LOT_STATUS.ABERTO,       // ABERTO | PROCESSANDO_BANHO | PROCESSANDO_MONTAGEM | FECHADO

  // Resumo do conteúdo do lote
  totalRawItems: 0,                // Quantidade de itens brutos
  totalFinishedItems: 0,           // Quantidade de itens prontos
  totalServiceItems: 0,            // Itens de serviço (se controlarmos por lote)

  // Blocos auxiliares (contagens e totais para UI)
  counts: {
    totalItensNF: 0,
    qtdBrutas: 0,
    qtdProntas: 0,
    qtdServicos: 0,
  },

  totals: {
    subtotalItens: 0,
    totalRateio: 0,
    totalGeral: 0,
  },

  // Controle de vínculos
  bathOperationsIds: [],           // IDs de operações de banho associadas
  assemblyIds: [],                 // IDs de montagens que usaram itens deste lote

  notes: '',
};

// ─────────────────────────────────────────────────────────────────────────────
// 4) PRODUTOS BRUTOS (RAW_PRODUCTS)
// ─────────────────────────────────────────────────────────────────────────────

export const RAW_PRODUCT_MODEL = {
  // Identificação
  sku: '',                         // SKU interno GS para a peça bruta
  nfId: '',                        // NF de origem
  nfItemId: '',                    // Item da NF que originou este bruto
  lotId: '',                       // Lote de origem
  supplierId: '',

  // Características físicas
  name: '',                        // Nome curto da peça bruta (separado do nome comercial futuro)
  weight: 0,                       // Peso unitário (em gramas)
  dimensions: {                    // Dimensões opcionais
    height: 0,
    length: 0,
    width: 0,
  },

  // Custos
  rawCost: 0,                      // Custo bruto unitário (após rateios)
  currency: 'BRL',

  // Status
  status: PRODUCT_STATUS.BRUTA,    // Sempre BRUTA neste modelo
  location: 'ESTOQUE_BRUTO',       // Localização lógica

  // Metadados
  createdAt: null,
  createdByUserId: '',
};

// ─────────────────────────────────────────────────────────────────────────────
// 5) PRODUTOS PRONTOS (FINISHED_PRODUCTS)
// ─────────────────────────────────────────────────────────────────────────────

export const FINISHED_PRODUCT_MODEL = {
  // Identificação
  sku: '',                         // SKU interno da peça pronta
  baseRawProductId: null,          // Se veio de um bruto específico (opcional)
  nfId: '',                        // NF de origem (quando veio direto como pronta)
  lotId: '',                       // Lote de origem
  supplierId: '',

  // Características
  nameInternal: '',                // Nome interno técnico (diferente de nome comercial final)
  weight: 0,                       // Peso final após banho/montagem (se aplicável)
  categoryId: null,
  tags: [],

  // Custos
  cost: 0,                         // Custo real final (bruto + banho + rateios de banho, etc.)
  rawCostPortion: 0,               // Parte do custo originada como bruto
  bathCostPortion: 0,              // Parte do custo originada no banho
  assemblyCostPortion: 0,          // Parte de custo via montagem (acessórios, etc.)
  currency: 'BRL',

  // Status de estoque
  status: PRODUCT_STATUS.EM_TRATAMENTO,   // EM_TRATAMENTO até passar pelo produto comercial
  location: 'ESTOQUE_PRONTO',

  // Relações com processos
  bathOperationId: null,           // Registro de banho que alterou o custo
  assemblyId: null,                // Registro de montagem que criou/alterou esta peça

  // Metadados
  createdAt: null,
  createdByUserId: '',
};

// ─────────────────────────────────────────────────────────────────────────────
// 6) OPERAÇÕES DE BANHO (BATH_OPERATIONS)
// ─────────────────────────────────────────────────────────────────────────────

export const BATH_OPERATION_MODEL = {
  lotId: '',                       // Lote de origem
  nfId: '',                        // NF de origem do lote (rastreamento)
  supplierServiceId: '',           // Fornecedor do serviço de banho (separado do fornecedor de bruto)

  // Parâmetros do banho
  goldGramPrice: 0,                // Valor do grama do banho informado pelo operador
  fixedServiceCost: 0,             // Custo fixo adicional (se houver)
  currency: 'BRL',

  // Itens processados
  items: [
    // Cada item contém vínculo com o bruto e o resultado no pronto
    {
      rawProductId: '',            // Produto bruto processado
      finishedProductId: '',       // Produto pronto gerado/atualizado
      rawWeight: 0,                // Peso da peça (g)
      rawCostBefore: 0,            // Custo antes do banho
      bathCostApplied: 0,          // Valor do banho aplicado nesta peça
      finalCostAfter: 0,           // Custo final da peça após banho
    },
  ],

  // Controle e histórico
  createdAt: null,
  createdByUserId: '',
};

// ─────────────────────────────────────────────────────────────────────────────
// 7) MONTAGENS / COMPOSIÇÕES (ASSEMBLIES)
// ─────────────────────────────────────────────────────────────────────────────

export const ASSEMBLY_MODEL = {
  assemblyType: ASSEMBLY_TYPES.SIMPLES,   // SIMPLES | COMPLEXA
  components: [
    {
      productId: '',             // ID de produto (sempre pronto, nunca BRUTA)
      sku: '',                   // SKU do componente
      quantity: 1,               // Quantidade usada
      costPortion: 0,            // Parte do custo daquele componente neste conjunto
    },
  ],

  // Resultado da montagem
  finalProductId: '',            // Produto final gerado
  finalSku: '',                  // SKU final (poderá seguir regra GS futura)
  finalCost: 0,                  // Soma dos custos dos componentes (ajustado)
  finalWeight: 0,                // Peso total (se calculado)
  currency: 'BRL',

  // Relações e rastreabilidade
  nfId: null,                    // Se vinculada a uma NF específica (opcional)
  lotId: null,                   // Se aplicada a itens de um lote específico (opcional)

  // Metadados
  createdAt: null,
  createdByUserId: '',
};

// ─────────────────────────────────────────────────────────────────────────────
// 8) PRODUTO COMERCIAL (COMMERCIAL_PRODUCTS)
// ─────────────────────────────────────────────────────────────────────────────

export const COMMERCIAL_PRODUCT_MODEL = {
  // Identificação
  finishedProductId: '',         // Referência ao produto pronto (custo já fechado)
  sku: '',                       // SKU herdado do finished product (regra GS)
  internalCode: '',              // Código opcional para controles internos

  // Dados comerciais
  commercialName: '',            // Nome que aparece para cliente (PDV/Catálogo)
  description: '',               // Descrição comercial
  categoryId: null,
  tags: [],

  // Imagens
  images: [],                    // URLs de imagens (máx. 4 no uso prático)

  // Precificação
  cost: 0,                       // Custo de base (deve bater com finished product)
  price: 0,                      // Preço de venda definido
  markup: 0,                     // Markup aplicado (opcional, calculado no painel)
  currency: 'BRL',

  // Exibição
  activeCatalog: true,           // Exibir no catálogo
  activePOS: true,               // Exibir no PDV
  rentalGroup: null,             // Grupo de aluguel (se aplicável)
  location: 'LOJA_FISICA',       // Localização comercial

  // Metadados
  createdAt: null,
  updatedAt: null,
  createdByUserId: '',
  updatedByUserId: '',
};

// ─────────────────────────────────────────────────────────────────────────────
// 9) MOVIMENTOS DE ESTOQUE (INVENTORY_MOVEMENTS)
// ─────────────────────────────────────────────────────────────────────────────

export const INVENTORY_MOVEMENT_MODEL = {
  productId: '',                         // ID do produto afetado
  sku: '',                               // SKU do produto
  movementType: INVENTORY_MOVEMENT_TYPES.NF_ENTRADA,
  quantityBefore: 0,                     // Quantidade antes do movimento
  quantityAfter: 0,                      // Quantidade após o movimento
  quantityDelta: 0,                      // Variação (positivo/negativo)

  // Contexto do movimento
  nfId: null,
  nfItemId: null,
  lotId: null,
  bathOperationId: null,
  assemblyId: null,
  saleId: null,                          // Futuro vínculo com PDV

  // Metadados
  createdAt: null,
  createdByUserId: '',
  notes: '',
};

// ─────────────────────────────────────────────────────────────────────────────
// 10) CUSTOS FINANCEIROS VINCULADOS (FINANCIAL_INPUTS)
// ─────────────────────────────────────────────────────────────────────────────

export const FINANCIAL_INPUT_MODEL = {
  nfId: '',                              // NF a que se refere
  lotId: null,                           // Lote, se custo for mais específico
  type: FINANCIAL_INPUT_TYPES.FRETE,     // FRETE | PEDAGIO | COMBUSTIVEL | ALIMENTACAO | OUTROS
  description: '',
  totalAmount: 0,                        // Valor total da despesa
  currency: 'BRL',

  // Rateio
  distributed: false,                    // Indica se já foi rateado entre itens
  distribution: [
    {
      nfItemId: '',                      // Item da NF que recebeu parte do custo
      amount: 0,                         // Valor rateado para esse item
    },
  ],

  createdAt: null,
  createdByUserId: '',
};

// ─────────────────────────────────────────────────────────────────────────────
// 11) ORDENS DE MONTAGEM (ASSEMBLY_ORDERS)
// ─────────────────────────────────────────────────────────────────────────────
//
// Entidade de workflow: o que será impresso, enviado ao setor de montagem e
// posteriormente baixado. A montagem final em si continua registrada em
// ASSEMBLIES (ASSEMBLY_MODEL), permitindo separar “pedido” de “execução”.

export const ASSEMBLY_ORDER_MODEL = {
  orderNumber: '',                       // Código da ordem (ex.: OM2025-0001)
  status: ASSEMBLY_ORDER_STATUS.ABERTA,  // ABERTA | EM_ANDAMENTO | CONCLUIDA | CANCELADA

  // Vínculos de origem
  nfId: null,                            // Se originada de uma NF específica (opcional)
  lotId: null,                           // Se ligada a um lote específico (opcional)

  // Componentes que devem ser usados na montagem
  components: [
    {
      productId: '',                     // ID do produto pronto a ser consumido
      sku: '',                           // SKU do componente
      quantity: 1,                       // Quantidade que sairá do estoque
    },
  ],

  // Resultado da ordem
  assemblyId: null,                      // Referência ao registro em ASSEMBLIES quando concluída

  // Controle operacional
  requestedByUserId: '',                 // Quem abriu a ordem
  assignedToUserId: '',                  // Quem é o responsável (ex.: Cris)
  printedAt: null,                       // Quando a OS foi impressa
  startedAt: null,                       // Quando a execução começou
  finishedAt: null,                      // Quando a execução foi concluída / baixa feita

  notes: '',                             // Observações internas

  // Metadados
  createdAt: null,
  createdByUserId: '',
};

// ╔══════════════════════════════════════════════════════════════════════════╗
// ║                     OBJETO CONSOLIDADO DO DATA MODEL                     ║
// ╚══════════════════════════════════════════════════════════════════════════╝

export const GSM_DATA_MODEL = {
  collections: GSM_COLLECTIONS,
  enums: {
    ITEM_TYPES,
    PRODUCT_STATUS,
    LOT_STATUS,
    INVENTORY_MOVEMENT_TYPES,
    ASSEMBLY_TYPES,
    FINANCIAL_INPUT_TYPES,
    ASSEMBLY_ORDER_STATUS,
  },
  models: {
    NF_ENTRY_MODEL,
    NF_ITEM_MODEL,
    LOT_MODEL,
    RAW_PRODUCT_MODEL,
    FINISHED_PRODUCT_MODEL,
    BATH_OPERATION_MODEL,
    ASSEMBLY_MODEL,
    COMMERCIAL_PRODUCT_MODEL,
    INVENTORY_MOVEMENT_MODEL,
    FINANCIAL_INPUT_MODEL,
    ASSEMBLY_ORDER_MODEL,
  },
};
